<template>
  <section class="section-info">
    <div class="section-info-content">
      <div class="info-name">
        <h2>費用</h2>
        <inline-svg
          :src="require('../../assets/icon/svg/dollar-rounded.svg')"
        />
      </div>
      <div class="info-primary">
        <p>非會員充電費率</p>
        <div class="info-primary__power">
          <span class="info-primary__count">{{
            unitPrice.unitPrice.toFixed(1)
          }}</span>
          <div class="info-primary__spec mb-1">
            <span>元/kWh</span>
          </div>
        </div>
      </div>
      <div class="info-location">
        <p>您所在的位置：{{ station.station }}</p>
      </div>
    </div>
  </section>
</template>
<script>
import { mapState } from "vuex";
export default {
  name: "FeeInfoCard",
  props: {
    unitPrice: { type: Object, require: true },
  },
  computed: {
    ...mapState(["station"]),
  },
};
</script>
